import Config from '../Config';
import { RestService } from './RestService';

export const PromotionService = {
    getPromotionsList: async function(start, numberItems, filter, sort, direction){
        return RestService.get(`${Config.get_promotions_url}from=${start}&offset=${numberItems}&filter=${filter}&sort=${sort}&direction=${direction}`, {})
        .then(response => response.json());
    },
    getPromotionDetails: async function(promotion_id){
        return RestService.get(`${Config.get_promotiondetails}promotion_id=${promotion_id}`, {})
        .then(response => response.json());
    },
    getTotalCount: async function() {
        return RestService.get(`${Config.total_count}data_type=PROMOTION`, {})
        .then(response => response.json());
    },
    togglePromotionStatus: async function(id) {
        return RestService.get(`${Config.toggle_promotion_status}promotion_id=${id}`, {})
        .then(response => response.json())
    },
    createPromotion: async function(body) {
        return RestService.post(`${Config.create_promotion}`, {}, body)
        .then(response => response.json());
    },
    removePromotion: async function(id) {
        return RestService.get(`${Config.remove_promotion}id=${id}`, {})
        .then(response => response.json());
    },
};